import PatDefenseComplete from "../../../../football/rules/general/scoring/pat-defense-complete";
import DefaultFlagFootballConfig from "../../../config/default";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

/**
 * Defense returns an intercepted try to the end zone: 2 points (USA Flag
 * 4-1-2, 2023 Flag Rules 8-1-1).
 *
 * With no kickoff the defense keeps possession afterwards - it receives the
 * next drive, the same end state FlagPatFail/FlagPatComplete leave behind,
 * and unlike the football rule which restores possession to the try team.
 * When kickoffs are enabled that restore is what we want instead, because
 * the try team kicks off however the try ended.
 */
export default class FlagPatDefenseComplete extends PatDefenseComplete {
    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { play }) {
        // Configs persisted before the key existed lack it; an undefined
        // here turns the score into NaN, so fall back to the flag default.
        const points =
            gameContext.gameConfig.scoring?.defensivePAT ??
            DefaultFlagFootballConfig.scoring.defensivePAT;

        // No interception rule runs in the PAT tree, so the context still
        // holds the try team in possession here.
        gameContext.switchPossession();
        gameContext.increaseTeamPossessionScore(points);
        ruleContext.playPoints = points;

        // With kickoffs enabled the try team kicks off regardless of how the
        // try ended, so hand possession back - the same restore the football
        // rule does on its last line, and why this override exists at all.
        // Without kickoffs the defense keeps the ball and receives the next
        // drive, which is the pre-kickoff flag behaviour.
        if (isKickoffEnabled(gameContext)) {
            gameContext.switchPossession();
        }
    }
}
